<template>
    <v-dialog
        v-model="showDialog"
        width="600"
    >
        <v-card>
            <v-form
                ref="form"
                @submit.prevent="submitForm"
            >
                <v-card-title
                    style="background-color: #009688; color: white;"
                >
                    Delete coverage: {{ data && data.DIAG_T ? data.DIAG_T : '' }}
                </v-card-title>
                <v-card-text>
                    <v-text-field
                        v-model.trim="deleteData.DIAG_T"
                        readonly
                        label="Diagnostic"
                        color="teal"
                    />
                    <v-select
                        v-model.trim="deleteData.SCOPE"
                        label="Scope"
                        :items="scopeItem"
                        color="teal"
                        readonly
                    />
                    <v-text-field
                        v-model.trim="deleteData.AGE_MN"
                        readonly
                        label="Min Age"
                        color="teal"
                        suffix="y.o."
                    />
                    <v-text-field
                        v-model.trim="deleteData.AGE_MX"
                        readonly
                        label="Max Age"
                        color="teal"
                        suffix="y.o."
                    />
                    <v-select
                        v-model.trim="deleteData.SEX"
                        readonly
                        label="Sex"
                        :items="sexItem"
                        item-text="label"
                        item-value="value"
                        color="teal"
                    >
                        <template #item="{ item }">
                            <v-icon :color="item.value === 'F' ? 'pink' : item.value === 'M' ? 'blue' : ''">
                                {{ item.value === 'F' ? mdiGenderFemale : item.value === 'M' ? mdiGenderMale : '' }}
                            </v-icon> &nbsp;{{ item.label }}
                        </template>
                    </v-select>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        color="teal darken-1"
                        outlined
                        @click="showDialog = false"
                    >
                        close
                    </v-btn>
                    <v-btn
                        type="submit"
                        color="teal darken-1 white--text"
                    >
                        delete
                    </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import {
    mdiGenderFemale,
    mdiGenderMale
} from '@mdi/js'

export default {
    props: ['show', 'data'],
    data: ()=>({
        mdiGenderFemale,
        mdiGenderMale,
        sexItem: [
            { label: 'All', value: 'A' },
            { label: 'Male', value: 'M' },
            { label: 'Female', value: 'F' }
        ],
        scopeItem: [
            'ACCOUNT',
            'MEMBER'
        ],
        deleteData: {
            ID: null,
            ACCT_N: null,
            ACCT_M: null,
            DIAG_T: null,
            AGE_MN: null,
            SEX: null,
            SCOPE: null
        }
    }),
    computed: {
        showDialog: {
            get() {
                if (this.show) this.initData()
                return this.show
            },
            set() {
                this.$emit('closeDialog')
            }
        }
    },
    methods: {
        ...mapActions(['deleteAccountCoverage', 'suggestAcuDiagnostics']),
        submitForm() {
            if (this.$refs && this.$refs.form.validate()) {
                this.deleteAccountCoverage(this.deleteData).then(() => this.suggestAcuDiagnostics())
            }
        },
        initData() {
            if (this.$refs && this.$refs.form) {
                this.$refs.form.resetValidation()
            }
            this.deleteData = structuredClone(this.data)
        }
    }
}
</script>
